export class ApprovalPending {
 public appRefNo: number;
 public name: string;
 public nic: string;
 public cdcNo: string;
 public type: string;
 public loginUser: string;
 public createdDate: string;
 public stage: string;
 public stageCode: string;
 public remark: string;
 public cocNo: string;
 public cdcExpDate: string;
 public cocDate: string;
 public familyName: string;
 public givenName: string;
 public initialName: string;
 public nicIssueDate: Date;
 public dob: Date;
 public gender: string;
 public birthPlace: string;
 public nationality: string;
 public specialCharac: string;
 public bioRefNo: string;
 public photoDate: string;
 public photoExpDate: string;
 public address: string;
 public mobile: string;
 public email: string;
 public cdcAvailable: string;
}
